import type { BillingStateSummary } from "@focal/ui-kit";
import { TServerErrorResponse } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const BILLING_STATE_SUMMARY_GET = "billing-state-summary-get";

/**
 * Billing-state summary: status + capabilities + slim subscription.
 * Responds for any authenticated user, including firms with expired or
 * invalid subscriptions — never guard this call behind subscription checks
 * (locked-out users need it to render the banner).
 */
export const getBillingStateSummary =
  async (): Promise<BillingStateSummary> => {
    try {
      const response = await http.get<BillingStateSummary>(
        links.billing.stateSummary,
      );
      return response.data;
    } catch (error) {
      throw error as TServerErrorResponse;
    }
  };
